import { AppBarV2 } from './AppBar/AppBarV2';
import { AppBarHeading } from './AppBarHeading/AppBarHeading';
import { MainLayoutProvider } from './Context/MainLayoutProvider';
import { CollapsibleVerticalNav } from './Drawer/CollapsibleVerticalNav';
import { CourseSelector } from './Drawer/CourseSelector';
import { LeftDrawerV2 } from './Drawer/LeftDrawerV2';
import { TermSelector } from './Drawer/TermSelector';
import { LayoutContainer } from './LayoutContainer/LayoutContainer';
import { BreadcrumbsV2 } from './MainContent/Breadcrumbs';
import { MainContentV2 } from './MainContent/MainContentV2';

export const MainLayout = {
  AppBar: AppBarV2,
  AppBarHeading,
  Breadcrumbs: BreadcrumbsV2,
  CollapsibleVerticalNav,
  CourseSelector,
  TermSelector,
  Drawer: LeftDrawerV2,
  LayoutContainer,
  Main: MainContentV2,
  Provider: MainLayoutProvider,
};
